/* ------------------------------------------------------------------ */
/*  Generic formatting helpers                                         */
/* ------------------------------------------------------------------ */

/** Return stringified value or a fallback (default "—") */
export const fmt = (val: unknown, fallback = "—"): string =>
	val !== null && val !== undefined && val !== "" ? String(val) : fallback;

/** Format an ISO date string to MM/DD/YYYY */
export const fmtDate = (iso: string | null | undefined) => {
	if (!iso) return "—";
	const d = new Date(iso);
	return Number.isNaN(d.getTime())
		? "—"
		: d.toLocaleDateString("en-US", {
				month: "2-digit",
				day: "2-digit",
				year: "numeric",
			});
};

/** Format an ISO timestamp to MM/DD/YYYY hh:mm AM/PM */
export const fmtDateTime = (iso: string | null | undefined) => {
	if (!iso) return "—";
	const d = new Date(iso);
	if (Number.isNaN(d.getTime())) return "—";
	return `${d.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" })} ${d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })}`;
};

/** Calculate age in years from a date-of-birth string */
export const calcAge = (dob: string | null | undefined) => {
	if (!dob) return "—";
	const birth = new Date(dob);
	if (Number.isNaN(birth.getTime())) return "—";
	const diff = Date.now() - birth.getTime();
	return `${Math.floor(diff / 31_557_600_000)}`;
};

/** Build uppercase initials from first + last name */
export const initials = (first?: string, last?: string) =>
	`${(first || "?")[0]}${(last || "?")[0]}`.toUpperCase();

/** Format a 10-digit phone number as (xxx) xxx-xxxx */
export const phone = (val: unknown) => {
	const raw = String(val ?? "").replace(/\D/g, "");
	if (raw.length === 10) {
		return `(${raw.slice(0, 3)}) ${raw.slice(3, 6)}-${raw.slice(6)}`;
	}
	return fmt(val);
};

export const toFixed2 = (num: number) => Number(num).toFixed(2);